import styled from "styled-components";

// body of page register
export const Containers = styled.div`
text-align:center;
`;

// title of page register
export const TitlePage = styled.h1`
text-align:center;
`;

// button of page register
export const DivBtn = styled.div`
position:relative;
top:25px;
`;


